import React from 'react';

const CalendarIcon = () => (
    <svg className="svg-icon calendar-icon" width="16px" height="20px" viewBox="5 3 16 20"
        xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g className="theme-path" fillRule="evenodd" transform="translate(0.000000, 0.000000)">
            <path d="M5,9 L21,9 L21,23 L5,23 L5,9 Z M16,19 L16,21 L18,21 L18,19 L16,19 Z M12,19 L12,21 L14,21 L14,
            19 L12,19 Z M8,19 L8,21 L10,21 L10,19 L8,19 Z M16,15 L16,17 L18,17 L18,15 L16,15 Z M12,15 L12,17 L14,17 L14,
            15 L12,15 Z M8,15 L8,17 L10,17 L10,15 L8,15 Z M16,11 L16,13 L18,13 L18,11 L16,11 Z M12,11 L12,13 L14,13 L14,
            11 L12,11 Z M8,11 L8,13 L10,13 L10,11 L8,11 Z M5,5 L21,5 L21,8 L5,8 L5,5 Z M9,3 L17,3 L17,4 L9,4 L9,3 Z">
            </path>
        </g>
    </svg>
);

export default CalendarIcon;
